var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('h1',[_vm._v(_vm._s(_vm.collection_name))])]),_vm._l((_vm.quotes_by_collection),function(quote){return _c('div',{key:quote.text},[_c('DuneQuote',{attrs:{"quote":quote}}),_c('v-divider')],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }